var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5667 29.9695C8.48464 31.1232 6.99756 32.8274 6.99756 35.2971C6.99756 38.9822 14.6098 41.9695 24 41.9695C33.3902 41.9695 41.0024 38.9822 41.0024 35.2971C41.0024 32.8274 39.1289 31.5679 34.0469 30.4142",
    stroke: "#F9F9F9",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.7958C22.8393 12.7958 21.8983 13.7367 21.8983 14.8974C21.8983 16.0581 22.8393 16.9991 24 16.9991C25.1607 16.9991 26.1016 16.0581 26.1016 14.8974C26.1016 13.7367 25.1607 12.7958 24 12.7958ZM19.8745 14.8974C19.8745 12.619 21.7215 10.772 24 10.772C26.2784 10.772 28.1254 12.619 28.1254 14.8974C28.1254 17.1759 26.2784 19.0229 24 19.0229C21.7215 19.0229 19.8745 17.1759 19.8745 14.8974Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0005 6.02381C28.9015 6.02381 32.8741 9.99666 32.8741 14.8974C32.8741 16.6197 32.2981 18.5957 31.3066 20.6813C30.3239 22.7484 28.9937 24.7973 27.6306 26.6305C26.9648 27.5259 26.2979 28.3608 25.6701 29.1113L26.9902 30.6858C30.3153 26.7572 34.8979 20.3533 34.8979 14.8974C34.8979 8.87899 30.0193 4 24.0005 4C17.9816 4 13.103 8.87899 13.103 14.8974C13.103 21.5333 19.4148 29.5718 22.2549 32.853C23.0794 33.8055 23.6113 34.3571 23.6113 34.3571C23.6113 34.3571 24.1625 33.8249 25.0214 32.9033C23.5094 31.2076 23.7053 31.4373 23.5094 31.2076C22.5554 30.0887 21.2862 28.5135 20.0211 26.6862C17.412 22.9175 15.1268 18.5042 15.1268 14.8974C15.1268 9.99666 19.0994 6.02381 24.0005 6.02381Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHere);
export default __webpack_public_path__ + "static/media/here.97e9669872d236fca622841b9fccc987.svg";
export { ForwardRef as ReactComponent };